import * as THREE from 'three';
function createStandardMaterial(color, roughness, metalness) {
    const material = new THREE.MeshStandardMaterial({
        color: color !== undefined ? color : 0xffffff,
        roughness: roughness !== undefined ? roughness : 0.5,
        metalness: metalness !== undefined ? metalness : 0.5
    });
    return material;
    
}
function createBasicMaterial(color, opacity) {
    const material = new THREE.MeshBasicMaterial({
      color: color || 0xffffff, // 默认颜色为白色
      opacity: opacity || 1, // 默认不透明
      transparent: opacity !== undefined && opacity < 1 // 如果透明度小于1，则开启透明度
    });
    return material;
  }

export {createStandardMaterial,createBasicMaterial}